<template>
    <button type="button" class="btn btn-secondary btn-sm me-1" @click="remove" :disabled="!canDelete"><i class="fa-solid fa-trash-can"></i></button>
</template>

<script>
export default {
    props: {
        value: {
            type: Object,
            default: function(data={}) {
                return {};
            }
        }
    },

    data() {
        return {
            id: this.value.id ?? null,
            canDelete: this.value.can_delete ?? true,
        };
    },

    methods: {
        remove: function() {
            this.$parent.isLoading = true;
            axios
                .delete(`/api/admin/areas/${this.id}`)
                .then((response) => {
                    this.$emit('input', this.id);
                })
                .catch((error) => {
                    console.error(error);
                })
                .finally(() => {
                    this.$parent.isLoading = false;
                })
        }
    }
}
</script>